// extracted by mini-css-extract-plugin
export default {"fieldset":"prompt-form_fieldset__z6vPp","input":"prompt-form_input__s1Yx6","error":"prompt-form_error__bOzCy","submitGroup":"prompt-form_submitGroup__MjkRD"};